<template>
  <div class="col-12 col-md-6 form-group form-group-sm">
    <label class="label" for="aditivo">Aditivos</label>
    <multiselect-item
      id="aditivo"
      v-model="aditivo"
      :close-on-select="false"
      :custom-label="label"
      :multiple="true"
      :options="aditivoOptions"
      placeholder="Seleccione aditivos"
      track-by="id_precios_aditivos"
    ></multiselect-item>
  </div>
</template>

<script>
import { get } from "lodash-es";
import axios from "axios";

export default {
  name: "SelectAditivos",
  beforeMount() {
    this.getAditivos().then((resp) => {
      if (!resp.ok) {
        this.$msgBoxOk(resp.message);
      }
    });
  },
  data: () => ({
    aditivoOptions: [],
  }),
  methods: {
    label(aditivo) {
      return `${aditivo.Aditivo} - Precio: ${aditivo.Precio}`;
    },
    async getAditivos() {
      const resp = await axios.post("/execute", {
        method: "CLI.GetAditivos",
        parameters: [],
      });

      this.aditivoOptions = get(resp, "data.result[0]", []);
      return resp.data;
    },
  },
  computed: {
    aditivo: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.aditivos;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setAditivos", val);
      },
    },
  },
};
</script>
